import { useEffect, useRef, useState } from "react";
import { Button } from "../../../components/Button";
import CheckIcon from "../../../assets/icons/check.svg?react";
import PinIcon from "../../../assets/icons/pin.svg?react";
import XIcon from "../../../assets/icons/x.svg?react";
import { fileUpload } from "../../../services/file-upload";
import { getToken, getUser, setUser } from "../../../services/utils";
import { api } from "../../../services/api";
import { ShowToast } from "../../../services/toast";
import { FileUploader } from "react-drag-drop-files";
import { ReferralFormType } from "./ClientReferral";
import { TextArea } from "../../../components/Textarea";
import { UploadView } from "../register/components/ManualUpload";

export function Step3({
  onSubmit,
  referralForm,
  setReferralForm
}: {
  onSubmit: (form: ReferralFormType) => void;
  referralForm: ReferralFormType;
  setReferralForm(value: ReferralFormType): void;
}) {
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState<any>({});

  const handleDEChange = (file: File | null) => {
    setReferralForm({ ...referralForm, deFile: file });
  };
  const handleLMNChange = (file: File | null) => {
    setReferralForm({ ...referralForm, lmnFile: file });
  };

  const handleSubmit = async () => {
    let newErrors: any = {};
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;
    setSaving(true);
    try {
      await onSubmit(referralForm);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="bg-white p-8 rounded-[16px]">
        <div>
          <h1 className="text-3xl font-bold mb-5">Client Referral - ABA Therapy</h1>
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold">Diagnostic Information</h2>
            <div className="text-sm text-black/60">3/3</div>
          </div>
        </div>
        <div className="mt-4">
          <div className="mb-6">
            <span className="text-black/80 text-sm font-medium">Please upload the diagnostic evaluation (DE) <span className="text-black/40">(Optional)</span></span>
            <UploadView
              text="Upload Diagnostic Evaluation (DE)"
              onChange={handleDEChange}
              value={referralForm.deFile}
              onRemove={() => handleDEChange(null)}
              allowPdf={true}
            />
            {errors.deFile && (
              <div className="text-red-500 text-xs font-medium mt-2 flex items-center gap-1">{errors.deFile}</div>
            )}
          </div>
          <div className="mb-6">
            <span className="text-black/80 text-sm font-medium">Please upload the letter of medical necessity (LMN) <span className="text-black/40">(Optional)</span></span>
            <UploadView
              text="Upload Letter of Medical Necessity (LMN)"
              onChange={handleLMNChange}
              value={referralForm.lmnFile}
              onRemove={() => handleLMNChange(null)}
              allowPdf={true}
            />
          </div>
        </div>
        <div className="flex flex-col mb-2">
          <span className="text-black/80 text-sm">Additional Information <span className="text-black/40">(Optional)</span></span>
          <TextArea
            placeholder="Any additional information about the client referral"
            className={`!p-[14px]`}
            name="comments"
            rows={3}
            value={referralForm.comments}
            onChange={(e) => {
              setReferralForm({ ...referralForm, comments: e.target.value });
            }}
            disabled={saving}
          />
          {errors.comments && (
            <div className="text-red-500 text-xs font-medium">{errors.comments}</div>
          )}
        </div>
        <div className="mt-10">
          <Button
            type="submit"
            variant="primary"
            className="!rounded-full w-full"
            onClick={handleSubmit}
            disabled={saving}
            loading={saving}
          >
            Submit Referral
          </Button>
        </div>
      </div>
    </>
  );
}
